module.exports = "<div class=\"rulesHeader\">\n\t<h2>CantizAI Rule Engine</h2>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/rules/common/header/header.component.html
// module id = 1430
// module chunks = 1